// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { xdc as _xdc } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the xdc chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 50
 * Chain Name: XinFin Network
 * Default Block Explorer: https://xdc.blocksscan.io
 * Default RPC URL: https://rpc.xinfin.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { xdc } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: xdc,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const xdc = createCommon({
	..._xdc,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
